// "use client";

import React from "react";
import Banner from "./banner";
import dynamic from "next/dynamic";
const Mission = dynamic(() => import("./mission"),{ssr: true});
const Strategy = dynamic(() => import("./strategy"),{ssr: true});
const Feedback = dynamic(() => import("./feedback"),{ssr: true});
const WhatWeBelieve = dynamic(() => import("./what-we-believe"),{ssr: true});
const BeyondRole = dynamic(() => import("./beyond-role"),{ssr: true});
const CoreBenefits = dynamic(() => import("./core-benefits"),{ssr: true});
const ConnectBanner = dynamic(() => import("./connect-banner"),{ssr: true});
const HocHead = dynamic(() => import("@/Components/HigherOrderComponent/HocHead"),{ssr: true});

// Define types for incoming props
interface Block {
  __component: string;
  [key: string]: any; // Allow extra fields since block structure varies
}

interface Seo {
  [key: string]: any;
}

interface LeadershipDetailsPageProps {
  data?: {
    blocks?: Block[];
    seo?: Seo;
  };
}

const LeadershipDetailsPage: React.FC<LeadershipDetailsPageProps> = ({
  data,
}) => {
  const seo = data?.seo || {};
  const blocks = Array.isArray(data?.blocks) ? data.blocks : [];
  return (
    <>
      {seo && <HocHead seo={seo} />}
      {blocks.length > 0 && (
        <div
          className="leadershipDetailsPage bg-one"
          style={{ marginTop: "-10px" }}
        >
          {blocks.map((block: any, i) => {
            switch (block?.__component) {
              case "blocks.leader-banner":
                return <Banner key={i} block={block} />;
              case "blocks.leader-mission":
                return <Mission key={i} block={block} />;
              case "blocks.philosophy":
                return <Strategy key={i} block={block} />;
              case "blocks.leader-quotes-block":
                return <BeyondRole key={i} block={block} />;
              case "blocks.about-us-believe-in":
                return <WhatWeBelieve key={i} block={block} />;
              case "blocks.leader-drive":
                return <CoreBenefits key={i} block={block} />;
              case "blocks.leader-quote-by-author":
                return <ConnectBanner key={i} block={block} />;
              case "blocks.leader-connect-block":
                return <Feedback key={i} block={block} />;

              default:
                return null;
            }
          })}
        </div>
      )}
    </>
  );
};

export default LeadershipDetailsPage;
